angular.module('dpw.components')
    .directive('dpwCheckbox', [function () {
        return {
            restrict: 'EA',
            scope: {
                name: '@',
                forId: '@',
                model: '=',
                text: '@',
                isDisabled: '=',
                required: '=',
                change: '&',
                onClick: '&?'
            },
            templateUrl: 'dpw-checkbox.html',
            controllerAs: 'ctrl',
            controller: ['$scope', function ($scope) {
                // the $digest process will start after triggering the change event, so the value in change function is old
                // another way is that using $watch to watch the model then invoke the change function.
                $scope.$watch('model', function (newValue, oldValue) {
                    if (newValue !== oldValue) {
                        $scope.change();
                    }
                });

                this.onClick = function ($event) {
                    setTimeout(function () {
                        $scope.onClick && $scope.onClick({$event: $event, checked: $scope.model});
                    });
                };
            }]
        };
    }]);
